module.exports = __webpack_public_path__ + "img/mypage03.8fa3509a.png";